import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Header from "../components/Header";
import { verifyToken, formatApiErrorDetail } from "../lib/auth";
import { useAuth } from "../context/AuthContext";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Loader2, XCircle } from "lucide-react";

export default function AdminVerify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) {
      setError("Missing sign-in token.");
      return;
    }
    (async () => {
      try {
        await verifyToken(token);
        await login();
        navigate("/admin", { replace: true });
      } catch (err) {
        setError(formatApiErrorDetail(err.response?.data?.detail) || "Could not verify link.");
      }
    })();
  }, [params, login, navigate]);

  return (
    <div className="min-h-screen bg-background">
      <Header active="admin" />
      <main className="max-w-md mx-auto px-6 py-20">
        <Card>
          <CardContent className="p-8 text-center">
            {error ? (
              <div data-testid="verify-error">
                <div className="h-12 w-12 rounded-full bg-destructive/10 flex items-center justify-center mx-auto mb-4">
                  <XCircle className="h-6 w-6 text-destructive" />
                </div>
                <h1 className="font-display font-700 text-xl text-foreground">Sign-in failed</h1>
                <p className="text-muted-foreground text-sm mt-1.5">{error}</p>
                <Button onClick={() => navigate("/admin")} className="mt-5" data-testid="back-to-login-btn">
                  Back to sign-in
                </Button>
              </div>
            ) : (
              <div className="py-6">
                <Loader2 className="h-8 w-8 text-primary animate-spin mx-auto mb-4" />
                <p className="text-muted-foreground">Signing you in…</p>
              </div>
            )}
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
